module.exports = __webpack_public_path__ + "img/GALLERY-SWIFT-SPORT-6.6e119171.jpg";